/* istanbul ignore file */

/* eslint-disable react/require-default-props */
import React from 'react';
import { number } from 'prop-types';
import Heading from '../heading';

var WrapperBottom = function WrapperBottom(_ref) {
  var formatDate = _ref.formatDate;
  var scl = 'scl-';
  var colorPlum = '#9e8f93';
  var enEspanol = '/experiencia/';
  var privacyPolicy = '/patient-rights-privacy/privacy-practices.cfm';
  var nondiscriminationNotice = '/patient-rights-privacy/nondiscrimination-accessibility-notice.cfm';
  var termsOfUse = '/patient-rights-privacy/terms-of-use.cfm';
  var infectionPrevention = '/infection-prevention.cfm';
  var siteMap = '/site-map.cfm';
  return /*#__PURE__*/React.createElement("div", {
    className: "".concat(scl, "wrapper-bottom")
  }, /*#__PURE__*/React.createElement("div", {
    className: "".concat(scl, "container")
  }, /*#__PURE__*/React.createElement("div", {
    className: "".concat(scl, "row")
  }, /*#__PURE__*/React.createElement("div", {
    className: "block-1"
  }, /*#__PURE__*/React.createElement(Heading, {
    color: colorPlum,
    variant: 6
  }, /*#__PURE__*/React.createElement(React.Fragment, null, "Sharp is not-for-profit and relies on fundraising. \xA9", ' ', formatDate, " Sharp HealthCare. All rights reserved."))), /*#__PURE__*/React.createElement("div", {
    className: "block-2"
  }, /*#__PURE__*/React.createElement("a", {
    className: "anchor en-espanol-link",
    href: enEspanol,
    target: "_blank"
  }, /*#__PURE__*/React.createElement(Heading, {
    color: colorPlum,
    variant: 6
  }, "En Espa\xF1ol"))), /*#__PURE__*/React.createElement("div", {
    className: "block-3"
  }, /*#__PURE__*/React.createElement("ul", {
    className: "unordered-list"
  }, /*#__PURE__*/React.createElement("li", {
    className: "list-item"
  }, /*#__PURE__*/React.createElement("a", {
    className: "anchor privacy-policy-link",
    href: privacyPolicy,
    target: "_self"
  }, /*#__PURE__*/React.createElement("p", {
    className: "paragraph"
  }, "Privacy Policy"))), /*#__PURE__*/React.createElement("li", {
    className: "list-item"
  }, /*#__PURE__*/React.createElement("a", {
    className: "anchor nondiscrimination-accessibility-notice-link",
    href: nondiscriminationNotice,
    target: "_self"
  }, /*#__PURE__*/React.createElement("p", {
    className: "paragraph"
  }, "Nondiscrimination Notice"))), /*#__PURE__*/React.createElement("li", {
    className: "list-item"
  }, /*#__PURE__*/React.createElement("a", {
    className: "anchor terms-of-use-link",
    target: "_self",
    href: termsOfUse
  }, /*#__PURE__*/React.createElement("p", {
    className: "paragraph"
  }, "Terms of Use"))), /*#__PURE__*/React.createElement("li", {
    className: "list-item"
  }, /*#__PURE__*/React.createElement("a", {
    className: "anchor infection-prevention-link",
    href: infectionPrevention,
    target: "_self"
  }, /*#__PURE__*/React.createElement("p", {
    className: "paragraph"
  }, "Infection Prevention"))), /*#__PURE__*/React.createElement("li", {
    className: "list-item"
  }, /*#__PURE__*/React.createElement("a", {
    className: "anchor sitemap-link",
    target: "_self",
    href: siteMap
  }, /*#__PURE__*/React.createElement("p", {
    className: "paragraph"
  }, "Sitemap"))))))));
};

WrapperBottom.propTypes = {
  /**
   * formatDate function to format year.
   */
  formatDate: number
};
export default WrapperBottom;